<template>
  <div class="object-types-panel">
    <el-cascader-panel
      v-model="localValue"
      :options="options"
      :props="cascaderProps"
      @change="handleChange"
      @visible-change="handleVisibleChange"
    />
  </div>
</template>

<script>
import { CascaderPanel } from 'element-ui'

export default {
  name: 'GenericFieldObjectTypes',
  components: {
    ElCascaderPanel: CascaderPanel
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    businessDomain: {
      type: String,
      required: true
    },
    userContext: {
      type: Object,
      default: () => ({})
    },
    additionalContext: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    localValue: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    cascaderProps() {
      return {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        emitPath: false
      }
    },
    
    //  Utiliser les données du /config avec transformation hiérarchique
    options() {
      if (this.field && this.field.dataSource && this.field.dataSource.data) {
        return this.buildHierarchy(this.field.dataSource.data)
      }
      console.warn('🚨 [SearchFieldObjectTypes] Pas de données field.dataSource.data')
      return []
    }
  },
  methods: {
        //  REPRODUCTION EXACTE de PostFilterObjectTypeSearchImmo.vue (ancien système)
        // L'ancien système filtrait les données puis retournait object.niveau >= minLevel
        // Pour les LOTS (minLevel=4) : liste plate de tous les types >= niveau 4
        // Pour les PROGRAMMES (minLevel=3) : hiérarchie complète >= niveau 3
        buildHierarchy(data) {
            if (!Array.isArray(data)) return []
            
            //  Déterminer le minLevel selon le contexte (reproduction exacte)
            const isLot = this.field && this.field.properties && this.field.properties.is_lot
            const minLevel = isLot ? 4 : 3
            const maxLevel = 99
            
            console.log(` [GenericFieldObjectTypes] Construction avec ${data.length} items, isLot=${isLot}, minLevel=${minLevel}`)
            
            //  ÉTAPE 1 : Filtrer selon minLevel/maxLevel (comme _remove dans l'ancien code)
            const filteredData = data.filter(item => {
                return item.niveau >= minLevel && item.niveau <= maxLevel
            })
            
            console.log(` [GenericFieldObjectTypes] Après filtrage: ${filteredData.length} items`)
            
            //  ÉTAPE 2 : Transformer en format cascader
            filteredData.forEach(item => {
                item.value = String(item.code)
                item.label = item.libelle
            })
            
            //  ÉTAPE 3 : Construire la hiérarchie (_groupBy + _keyBy de l'ancien code)
            const groupedByParents = {}
            filteredData.forEach(item => {
                const parentCode = item.parentCode
                if (parentCode !== undefined && parentCode !== null) {
                    if (!groupedByParents[parentCode]) {
                        groupedByParents[parentCode] = []
                    }
                    groupedByParents[parentCode].push(item)
                }
            })
            
            const objectsByCode = {}
            filteredData.forEach(item => {
                objectsByCode[item.code] = item
            })
            
            //  ÉTAPE 4 : Attacher les enfants aux parents
            Object.keys(groupedByParents).forEach(parentCode => {
                if (objectsByCode[parentCode]) {
                    objectsByCode[parentCode].children = groupedByParents[parentCode]
                }
            })
            
            // Pour les LOTS (minLevel=4) : retourne liste plate de tous les niveau 4+ (pas de hiérarchie)
            // Pour les PROGRAMMES/AGENCES (minLevel=3) : retourne UNIQUEMENT les racines (niveau 3)
            let result
            if (isLot) {
                // LOTS : liste plate de tous les items >= minLevel
                result = Object.values(objectsByCode).filter(item => item.niveau >= minLevel)
            } else {
                // PROGRAMMES/AGENCES : uniquement les racines (items sans parent dans les données filtrées)
                result = Object.values(objectsByCode).filter(item => {
                    return item.niveau === minLevel && (!item.parentCode || !objectsByCode[item.parentCode])
                })
            }
            
            console.log(` [GenericFieldObjectTypes] Résultat final: ${result.length} items (isLot=${isLot})`)
            if (result.length > 0) {
                console.log(` [GenericFieldObjectTypes] Exemples: ${result.slice(0, 5).map(r => r.label).join(', ')}`)
            }
            
            return result
        },
    
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('change', { field: this.field.name, value: val })
    },
    
    handleVisibleChange(visible) {
      // Quand le popup se ferme (visible = false), déclencher sauvegarde + recherche
      if (!visible) {
        this.$emit('popup-closed', {
          field: this.field.name,
          shouldTriggerSearch: true
        })
      }
    },
    
    setupAdaptiveWidth() {
      // Forcer la largeur adaptative avec JavaScript
      this.$nextTick(() => {
        const panel = this.$el.querySelector('.el-cascader-panel')
        if (panel) {
          // Observer les changements dans le cascader
          const observer = new MutationObserver(() => {
            this.updateWidth()
          })
          
          observer.observe(panel, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
          })
          
          // Mise à jour initiale
          this.updateWidth()
        }
      })
    },
    
    updateWidth() {
      this.$nextTick(() => {
        const panel = this.$el.querySelector('.el-cascader-panel')
        const menus = this.$el.querySelectorAll('.el-cascader-menu')
        
        if (panel && menus.length > 0) {
          const menuWidth = 280  // Largeur optimisée pour éviter l'espace perdu
          const totalWidth = menus.length * menuWidth
          
          
          // Forcer la largeur sur chaque menu individuellement
          menus.forEach((menu, index) => {
            menu.style.setProperty('width', `${menuWidth}px`, 'important')
            menu.style.setProperty('min-width', `${menuWidth}px`, 'important')
            menu.style.setProperty('max-width', `${menuWidth}px`, 'important')
            
            // FORCER la suppression des scrollbars horizontales et optimiser l'espace
            const menuWrap = menu.querySelector('.el-cascader-menu__wrap')
            const menuList = menu.querySelector('.el-cascader-menu__list')
            const scrollView = menu.querySelector('.el-scrollbar__view')
            const horizontalBar = menu.querySelector('.el-scrollbar__bar.is-horizontal')
            
            if (menuWrap) {
              menuWrap.style.setProperty('overflow-x', 'hidden', 'important')
              menuWrap.style.setProperty('margin-right', '0', 'important')
              menuWrap.style.setProperty('width', `${menuWidth}px`, 'important')
              menuWrap.style.setProperty('max-width', `${menuWidth}px`, 'important')
              menuWrap.style.setProperty('min-width', `${menuWidth}px`, 'important')
            }
            
            if (menuList) {
              menuList.style.setProperty('width', '100%', 'important')
              menuList.style.setProperty('max-width', 'none', 'important')
            }
            
            if (scrollView) {
              scrollView.style.setProperty('width', '100%', 'important')
            }
            
            if (horizontalBar) {
              horizontalBar.style.setProperty('display', 'none', 'important')
            }
            
          })
          
          // FORCER la largeur sur le panel cascader lui-même
          panel.style.setProperty('width', `${totalWidth}px`, 'important')
          panel.style.setProperty('min-width', `${totalWidth}px`, 'important')
          panel.style.setProperty('max-width', `${totalWidth}px`, 'important')
          
          // Forcer aussi sur le conteneur object-types-panel
          const objectTypesPanel = this.$el.querySelector('.object-types-panel')
          if (objectTypesPanel) {
            objectTypesPanel.style.setProperty('width', `${totalWidth}px`, 'important')
            objectTypesPanel.style.setProperty('min-width', `${totalWidth}px`, 'important')
            objectTypesPanel.style.setProperty('max-width', `${totalWidth}px`, 'important')
          }
          
          // Forcer la largeur sur les conteneurs parents
          let parent = this.$el.parentElement
          while (parent) {
            if (parent.classList.contains('el-dropdown-menu') || 
                parent.classList.contains('el-popper')) {
              parent.style.setProperty('width', `${totalWidth + 16}px`, 'important')
              parent.style.setProperty('min-width', `${totalWidth + 16}px`, 'important')
              parent.style.setProperty('max-width', `${totalWidth + 16}px`, 'important')
              break
            }
            parent = parent.parentElement
          }
        }
      })
    }
  },
  
  mounted() {
    // Délai pour laisser Element UI finir le rendu
    setTimeout(() => {
      this.setupAdaptiveWidth()
    }, 100)
  },
  
  updated() {
    // Forcer la mise à jour de la largeur après chaque update
    setTimeout(() => {
      this.updateWidth()
    }, 50)
  }
}
</script>

<style>
/* Styles de base pour le cascader - JavaScript gère la largeur dynamique */
.object-types-panel {
  display: inline-block;
}

.object-types-panel .el-cascader-panel {
  display: inline-flex;
  flex-direction: row;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: white;
}

.object-types-panel .el-cascader-menu {
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  flex-shrink: 0;
  border-right: 1px solid #e4e7ed;
}

.object-types-panel .el-cascader-menu:last-child {
  border-right: none;
}

.object-types-panel .el-cascader-node {
  padding: 8px 12px;
  white-space: nowrap;
  display: flex !important;  /* Forcer le flex pour une meilleure utilisation de l'espace */
  align-items: center !important;
}

.object-types-panel .el-cascader-node .el-checkbox {
  margin-right: 8px !important;
  flex-shrink: 0 !important;
}

.object-types-panel .el-cascader-node__postfix {
  margin-left: 8px !important;
  flex-shrink: 0 !important;
}

.object-types-panel .el-cascader-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: none;  /* Supprimer la limite pour utiliser tout l'espace disponible */
  flex: 1;  /* Utiliser tout l'espace disponible */
}

/* Optimiser l'espace dans les menus - FORCER avec des sélecteurs plus spécifiques */
.object-types-panel .el-cascader-menu .el-cascader-menu__wrap {
  overflow-x: hidden !important;  /* Supprimer la scrollbar horizontale */
  margin-right: 0 !important;  /* Supprimer la marge négative qui crée l'espace pour la scrollbar */
  width: 280px !important;  /* FORCER la largeur du wrap à 280px */
  max-width: 280px !important;
  min-width: 280px !important;
}

.object-types-panel .el-cascader-menu .el-cascader-menu__list {
  width: 100% !important;  /* Utiliser toute la largeur disponible */
  max-width: none !important;
}

.object-types-panel .el-cascader-menu .el-scrollbar__bar.is-horizontal {
  display: none !important;  /* Masquer complètement la scrollbar horizontale */
}

.object-types-panel .el-cascader-menu .el-scrollbar__view {
  width: 100% !important;  /* Forcer la vue à utiliser toute la largeur */
}

/* SUPER FORCE : Cibler directement tous les wraps de cascader dans notre panel */
.object-types-panel .el-scrollbar__wrap {
  width: 100% !important;
  max-width: none !important;
  margin-right: 0 !important;
}

.object-types-panel .el-cascader-node:hover {
  background-color: #f5f7fa;
}
</style>
